import clsx from 'clsx';
import React from 'react';
import { getDurationRange } from '../../../../../domain/filters';
import { TW_RING } from '../../../../../domain/websiteDomain';
import { FetchSessionsMinimalQueryVariables } from '../../../../../typescript/generated/codegen';

interface DurationProps {
  filters: FetchSessionsMinimalQueryVariables;
  setFilters: (filters: FetchSessionsMinimalQueryVariables) => void;
}

const Duration: React.FC<DurationProps> = ({ filters, setFilters }) => {
  const handleSetDuration = (duration: number) => {
    const range = getDurationRange(duration);

    if (!range) return null;

    setFilters({
      ...filters,
      minDuration: range.min * 60,
      maxDuration: range.max * 60,
    });
  };

  const handleClearDuration = () =>
    setFilters({ ...filters, minDuration: undefined, maxDuration: undefined });

  return (
    <div className="grid grid-cols-3 gap-4">
      {[10, 20, 30, 40, 45, 50, 60, 90].map(duration => {
        const range = getDurationRange(duration);

        if (!range) return null;

        const isSelected =
          filters.minDuration === range?.min * 60 &&
          filters.maxDuration === range?.max * 60;

        return (
          <button
            key={`duration-${duration}`}
            className={clsx(
              'h-48px rounded-full box-border border border-accent-light',
              TW_RING,
              isSelected && 'bg-accent-light',
              !isSelected && 'hover:border-accent'
            )}
            onClick={() =>
              isSelected ? handleClearDuration() : handleSetDuration(duration)
            }
          >
            {`${duration} min`}
          </button>
        );
      })}
    </div>
  );
};

export default Duration;
